import React, { useMemo } from 'react';
import { Tabs } from 'antd';
import BillPeriodEstimatedIncomePage from './BillPeriodEstimatedIncomePage';
import BillPeriodEstimatedReceivablePage from './BillPeriodEstimatedReceivablePage';
import { hasResource } from 'utils/resourceAuth';
import { ResourceCode } from 'constants/resourceCodes';

const BillingPeriodIncomeStatisticsPage: React.FC = () => {
    const hasEstimated = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_BILLING_PERIOD_ESTIMATED]);
    const hasReceivable = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_BILLING_PERIOD_RECEIVABLE]);

    const items = useMemo(() => {
        return [
            hasEstimated && {
                label: '预估收入',
                key: 'estimated-income',
                children: <BillPeriodEstimatedIncomePage />,
            },
            hasReceivable && {
                label: '预估应收（账期维度）',
                key: 'estimated-receivable',
                children: <BillPeriodEstimatedReceivablePage />,
            },
        ].filter(Boolean) as { label: string; key: string; children: React.ReactNode }[];
    }, [hasEstimated, hasReceivable]);

    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            <Tabs
                items={items}
                size="large"
                defaultActiveKey="estimated-income"
                destroyInactiveTabPane={true}
            />
        </div>
    );
};

export default BillingPeriodIncomeStatisticsPage;